<template>
  <div v-editable="blok" class="py-0.5">
    <CMSLink
      v-if="blok"
      :cms-link="blok.labelLink"
      class="flex flex-col items-center justify-center px-[15px] hover:cursor-pointer"
      data-test-id="icon-slider-slide-link"
      @click.capture="$emit('click:icon-slide', blok)"
    >
      <AssetImage
        :blok="assetImage"
        image-class="w-[70px] pb-[25px] h-[95px]"
      />

      <h2 class="text-center text-base font-medium text-black md:text-lg">
        {{ blok.label }}
      </h2>
    </CMSLink>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { PropType } from 'vue'
import type { SbIconSliderSlide } from '~/cms/storyblok/types/storyblok.d.ts'

const props = defineProps({
  blok: {
    type: Object as PropType<SbIconSliderSlide>,
    default: () => {},
  },
})
defineEmits(['click:icon-slide'])

const assetImage = computed(() => props.blok.iconDesktop[0])
</script>
